import { FaQuoteLeft } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { FaStar } from "react-icons/fa";

const Testimonials = () => {
  const testimonials = [
    {
      quote: "Khana bhut acha he",
      name: "Mahendra Singh",
      profession: "Profession",
      rating: 5,
      image:
        "https://lh3.googleusercontent.com/a/ACg8ocIHg1KpUhz4zS_O2DlGi5zjbVV7JigmhTBlhLPFgQSI=w80-h80-c-rp-mo-br100",
    },
    {
      quote:
        "I am very happy Dil kush ho gya khana kak and full good service 😘😘😘😘",
      name: "Sonu Pal",
      profession: "Profession",
      rating: 4,
      image:
        "https://lh3.googleusercontent.com/a/ACg8ocI6nT8JmLyDPDuI4pVTaboQdBq6aYzvGADo-HcAVeaK=w80-h80-c-rp-mo-br100",
    },
    {
      quote: "Like the food here, delicious and authentic ❤️❤️✨",
      name: "Manika Chouhan",
      profession: "Profession",
      rating: 5,
      image:
        "https://lh3.googleusercontent.com/a-/ALV-UjXUPTX80UZHdWrnUlzGBv-Nlgrtje3BO6knKHBxbAy3qQ=w80-h80-c-rp-mo-br100",
    },
    {
      quote: "interior is good...",
      name: "OPTIMIST Thought",
      profession: "Profession",
      rating: 3,
      image:
        "https://lh3.googleusercontent.com/a-/ALV-UjUFeJcjh9goBvqJtzBN-vvwhfiWvPwXPI8z2UAMSZ6T2A=w80-h80-c-rp-mo-br100",
    },
  ];

  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10"
        onClick={onClick}
      >
        <FaArrowRight className="text-4xl border shadow-md text-primary bg-white rounded-full p-2 cursor-pointer" />
      </div>
    );
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10"
        onClick={onClick}
      >
        <FaArrowLeft className="text-4xl border shadow-md text-primary bg-white rounded-full p-2 cursor-pointer" />
      </div>
    );
  };

  // Track active center slide
  const [activeSlide, setActiveSlide] = useState(0); // Changed initial state to 0

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    focusOnSelect: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024, // large screens
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 900, // tablet (new)
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 768, // mobile
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
    beforeChange: (current, next) => setActiveSlide(next),
    afterChange: (current) => setActiveSlide(current),
  };

  return (
    <div className="py-8 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h5 className="text-lg font-medium text-primary font-serif mb-2">
            Testimonial
          </h5>
          <h1 className="font-display text-4xl font-bold text-gray-800 mb-5">
            Customer Reviews
          </h1>
        </div>

        <div className="slider-container px-6 sm:px-12 relative">
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => {
              const isCenter = index === activeSlide;
              return (
                <div key={index} className="px-2 focus:outline-none">
                  <div
                    className={`border rounded-md p-6 h-[14rem] shadow-sm transition-all duration-300 ${
                      isCenter
                        ? "sm:bg-primary bg-[#F4F4F4] sm:text-white text-black"
                        : "bg-[#F4F4F4] text-gray-800 scale-95"
                    }`}
                  >
                    <FaQuoteLeft
                      className={`text-2xl mb-4 ${
                        isCenter
                          ? "text-primary sm:text-white"
                          : "text-primary"
                      }`}
                    />

                    <div className="flex items-center">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-12 h-12 rounded-full object-cover"
                      />
                      <div className="ml-4">
                        <h5
                          className={`font-bold ${
                            isCenter ? "sm:text-white" : "text-gray-800"
                          }`}
                        >
                          {testimonial.name}
                        </h5>
                        <p
                          className={`text-xs ${
                            isCenter ? "sm:text-white" : "text-gray-500"
                          }`}
                        >
                          23/09/2023
                        </p>
                      </div>
                    </div>
                    <div className="flex my-3">
                      {[...Array(5)].map((_, i) => (
                        <FaStar
                          key={i}
                          className={`text-base mr-1 ${
                            i < testimonial.rating
                              ? isCenter
                                ? " text-primary sm:text-white"
                                : "text-primary"
                              : isCenter
                              ? "text-white/30"
                              : "sm:text-gray-300 text-white/30"
                          }`}
                        />
                      ))}
                    </div>
                    <p className="">{testimonial.quote}</p>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
